module.exports = __webpack_public_path__ + "img/8001.9890cf1a.gif";